import app from "flarum/forum/app";
import Button from "flarum/common/components/Button";
import RankDataPage from "../RankDataPage";

enum SCPType {
  AsDD = "as_dd",
  AsScientist = "as_scientist",
  AsSCP = "as_scp",
  AsMTF = "as_mtf",
  AsCI = "as_ci",
  AsSerpent = "as_serpent",
  KilledDD = "killed_dd",
  KilledScientist = "killed_scientist",
  KilledSCP = "killed_scp",
  KilledMTF = "killed_mtf",
  KilledCI = "killed_ci",
  KilledSerpent = "killed_serpent",
  Killed682 = "killed_682",
  Killed096 = "killed_096",
  EscortO5 = "escort_o5",
  GotDamage = "got_dmg"
}

export default class SCPRankPage extends RankDataPage {
  type = SCPType.AsDD;

  title(): string {
    return app.translator.trans("rhodes-island.forum.rank.scp_title") as string
  }

  ranksUrl() {
    return "https://rhd-api.tenmahw.com/scp/player/ranks/" + this.type;
  }

  rankUrl(steamid: string) {
    return `https://rhd-api.tenmahw.com/scp/player/rank/${this.type}/?steamid=${steamid}`;
  }

  getTypes(): any[] {
    const types = [];

    for (const i in SCPType) {
      types.push(Button.component({
        // @ts-ignore
        active: this.type === SCPType[i],
        // @ts-ignore
        onclick: () => this.changeType(SCPType[i]),
        // @ts-ignore
      }, app.translator.trans("rhodes-island.forum.scp_data." + SCPType[i])));
    }

    return types;
  }

  playerLink(steamid: string): string {
    return app.route("player.scp_data", {steamid});
  }
}
